import { render, staticRenderFns } from "./ComplexCard.vue?vue&type=template&id=50efab9f&scoped=true&lang=pug&"
import script from "./ComplexCard.vue?vue&type=script&lang=js&"
export * from "./ComplexCard.vue?vue&type=script&lang=js&"
import style0 from "./ComplexCard.vue?vue&type=style&index=0&id=50efab9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efab9f",
  null
  
)

export default component.exports